export var RulebookListCardStatus;
(function (RulebookListCardStatus) {
    RulebookListCardStatus["DRAFT"] = "draft";
    RulebookListCardStatus["NEEDS_CHANGES"] = "needsChanges";
    RulebookListCardStatus["IN_REVIEW"] = "inReview";
    RulebookListCardStatus["PUBLIC"] = "public";
    RulebookListCardStatus["PRIVATE"] = "private";
})(RulebookListCardStatus || (RulebookListCardStatus = {}));
export default RulebookListCardStatus;
